import P2Medium from 'components/typography/P2Medium';
import { SystemExportRow } from 'components/tables/data/system-export/types';

/**
 * Column for the organization name.
 */
export default function OrganizationNameColumn({ data: { organization } }: { data: SystemExportRow }) {
  return <P2Medium color="gray.8">{organization.organizationName}</P2Medium>;
}
